import { useTranslation } from "react-i18next";
import { LegalPage } from "@/components/LegalPage";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = [1, 2, 3, 4, 5].map((n) => [t(`legalPages.p${n}t`), t(`legalPages.p${n}b`)]);
  return <LegalPage testId="privacy-page" title={t("legalPages.privacyTitle")} intro={t("legalPages.privacyIntro")} sections={sections} />;
}
